import { Loader } from '@/components/atoms'
import { AppTitle } from '@/components/atoms/AppTitle/AppTitle'
import styles from '@/features/Auth/ui/AuthWalletConnected/AuthWalletConnected.module.scss'
import { AppRoutes } from '@/routes'
import { formatSolanaPublicKey } from '@/shared/helpers/string'
import { useAuthStore } from '@/store'
import { Button, Flex } from 'antd'
import { useRouter } from 'nextjs-toploader/app'
import React, { useCallback } from 'react'

// Reads from the auth store rather than the live wallet connection: by this point in the
// flow the wallet is already confirmed and selectedPublicKey is authoritative, and reading it
// here avoids depending on live wallet-adapter/AppKit context state that may already be
// tearing down as the flow completes.
export function AuthWalletConfirmed() {
  const publicKey = useAuthStore((state) => state.selectedPublicKey)
  const router = useRouter()

  const handleIndexPage = useCallback(() => {
    router.push(AppRoutes.INDEX_PAGE)
  }, [router])

  if (!publicKey) return <Loader />

  return (
    <Flex vertical justify="center" align="center" className="mobileContainer">
      <Flex className="w-full" flex={1} gap={15} justify="center" vertical>
        <span className={styles.icon}>🎉</span>
        <AppTitle text="Easy Peasy" centered />
        <p className={styles.text}>
          Wallet
          {' '}
          <strong>{formatSolanaPublicKey(publicKey, 4)}</strong>
          {' '}
          successfully
          <br />
          connected to GoDefi
        </p>
      </Flex>
      <Button
        className="mobilePrimaryButton w-full mt-auto"
        onClick={handleIndexPage}
        type="primary"
        size="large"
      >
        Got it
      </Button>
    </Flex>
  )
}
